import { service } from "../utils/request";

//订单列表
export function OrderList(data) {
  return service({
    url: "shop/agent.order/index",
    method: "post",
    data: data
  });
}
export function convenience_store_index(data) {
  return service({
    url: "creditshop/agent.creditshop_goods_order/convenience_store_index",
    method: "get",
    params: data
  });
}
export function statistics(data) {
  return service({
    url: "creditshop/agent.creditshop_goods_order/statistics",
    method: "get",
    params: data
  });
}

//订单详情
export function OrderDetail(data) {
  return service({
    url: "shop/agent.order/detail",
    method: "post",
    data: data
  });
}

//取消订单的原因列表
export function CancelReason(data) {
  return service({
    url: "shop/agent.order/cancelReason",
    method: "post",
    data: data
  });
}

//取消订单
export function Cancel(data) {
  return service({
    url: "shop/agent.order/cancel",
    method: "post",
    data: data
  });
}

//删除已取消的订单
export function DeleteOrder(data) {
  return service({
    url: "shop/agent.order/del",
    method: "post",
    data: data
  });
}

//快递公司列表
export function postcompany(data) {
  return service({
    url: "shop/agent.order/postcompany",
    method: "post",
    data: data
  });
}

//添加标记
export function EditTag(data) {
  return service({
    url: "shop/agent.order/editTag",
    method: "post",
    data: data
  });
}

//获取标记
export function GetTag(data) {
  return service({
    url: "shop/agent.order/getTag",
    method: "post",
    data: data
  });
}

//订单发货
export function Delivery(data) {
  return service({
    url: "shop/agent.order/delivery",
    method: "post",
    data: data
  });
}

//修改价格
export function EditPrice(data) {
  return service({
    url: "shop/agent.order/editPrice",
    method: "post",
    data: data
  });
}

//修改收货地址
export function EditAddress(data) {
  return service({
    url: "shop/agent.order/editAddress",
    method: "post",
    data: data
  });
}

//获取收货信息
export function GetDeliveryInfo(data) {
  return service({
    url: "shop/agent.order/getDeliveryInfo",
    method: "post",
    data: data
  });
}

//获取订单流程时间
export function GetTimeSetting(data) {
  return service({
    url: "shop/agent.Shoporderset/detail",
    method: "post",
    data: data
  });
}

//设置订单流程时间
export function SetTimeSetting(data) {
  return service({
    url: "shop/agent.Shoporderset/edit",
    method: "post",
    data: data
  });
}

//积分商城发货
export function integralShopSend(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods_Order/send",
    method: "post",
    data: data
  });
}
//条码中商品
export function get_goods_by_barcode(data) {
  return service({
    url: "creditshop/agent.creditshop_goods/get_goods_by_barcode",
    method: "get",
    params: data
  });
}
//条码对应商品
export function get_goods_info_by_barcode(data) {
  return service({
    url: "creditshop/agent.creditshop_goods/get_goods_info_by_barcode",
    method: "get",
    params: data
  });
}
//便利店订单创建
export function submit_shoporder_money(data) {
  return service({
    url: "creditshop/agent.creditshop_goods_order/submit_shoporder_money",
    method: "post",
    data: data
  });
}
//便利店订单详情
export function detail(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods_Order/detail",
    method: "get",
    params: data
  });
}
//便利店订单确认
export function confirm_order_money(data) {
  return service({
    url: "creditshop/agent.creditshop_goods_order/confirm_order_money",
    method: "post",
    data: data
  });
}
//删除订单
export function deleteOrderList(data) {
  return service({
    url: "offlinestore/agent.order/deleteOrderList",
    method: "post",
    data: data
  });
}
//删除订单恢复
export function recoverOrder(data) {
  return service({
    url: "offlinestore/agent.order/recoverOrder",
    method: "post",
    data: data
  });
}
//删除充值订单
export function deleteRechargeList(data) {
  return service({
    url: "offlinestore/agent.recharge/deleteRechargeList ",
    method: "post",
    data: data
  });
}
//删除充值订单恢复
export function recoverRecharge(data) {
  return service({
    url: "offlinestore/agent.recharge/recoverRecharge",
    method: "post",
    data: data
  });
}
//删除充值订单恢复
export function print_credit_order(data) {
  return service({
    url: "creditshop/agent.creditshop_goods_order/print_credit",
    method: "post",
    data: data
  });
}
//删除订单
export function deleteOrder_pt(data) {
  return service({
    url: "manage/order.normal_order/deleteOrder",
    method: "post",
    data: data
  });
}